import { useLoggedInUser } from "./useLoggedInUser.ts";

export const useIsLoggedIn = (): boolean | undefined => {
  const user = useLoggedInUser();
  return user.isPending ? undefined : !!user.data?.id;
};
